import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedSmartPageEditorStepWithI18n } from './delayed-smart-page-editor-step';

export const SmartPageEditorStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.SMART_PAGE_EDITOR,
  render: () => <DelayedSmartPageEditorStepWithI18n />,
};
